import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { SocialProofNotification } from './components/SocialProofNotification';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="w-full min-h-screen bg-white overflow-x-hidden" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" />} data-id="element-5" />
          <Route path="/terms-and-conditions" element={<TermsAndConditions data-id="element-8" />} data-id="element-7" />
        </Routes>
        {/* Social proof toast — fixed positioned, lives at the root, never inside any section */}
        <SocialProofNotification data-id="element-9" />
      </div>
    </BrowserRouter>;
}